import { render, staticRenderFns } from "./BuildingOperation.vue?vue&type=template&id=3084b288&scoped=true"
import script from "./BuildingOperation.vue?vue&type=script&lang=js"
export * from "./BuildingOperation.vue?vue&type=script&lang=js"
import style0 from "./BuildingOperation.vue?vue&type=style&index=0&id=3084b288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3084b288",
  null
  
)

export default component.exports